// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sellix Shepherd theme — overrides default Shepherd CSS */
.shepherd-element.sellix-shepherd {
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    box-shadow:
        0 20px 25px -5px rgba(0, 0, 0, 0.1),
        0 8px 10px -6px rgba(0, 0, 0, 0.1);
    font-family: "Geist", "Inter", sans-serif;
    max-width: 360px;
}
.shepherd-element.sellix-shepherd .shepherd-content {
    border-radius: 12px;
    overflow: hidden;
}
.shepherd-element.sellix-shepherd .shepherd-header {
    background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
    padding: 14px 16px 12px;
}
.shepherd-element.sellix-shepherd .shepherd-title {
    color: white !important;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: -0.01em;
}
.shepherd-element.sellix-shepherd .shepherd-cancel-icon {
    color: rgba(255, 255, 255, 0.7) !important;
    font-size: 18px;
}
.shepherd-element.sellix-shepherd .shepherd-cancel-icon:hover {
    color: white !important;
}
.shepherd-element.sellix-shepherd .shepherd-text {
    color: #334155;
    font-size: 13px;
    line-height: 1.55;
    padding: 14px 16px 10px;
}
.shepherd-element.sellix-shepherd .shepherd-footer {
    padding: 8px 12px 12px;
    border-top: 1px solid #f1f5f9;
    background: #fafbfc;
    display: flex;
    justify-content: flex-end;
    gap: 6px;
}
.shepherd-element.sellix-shepherd .shepherd-button {
    background: #4f46e5;
    color: white;
    font-size: 12px;
    font-weight: 500;
    padding: 6px 14px;
    border-radius: 6px;
    border: none;
    cursor: pointer;
    transition: background 120ms ease;
}
.shepherd-element.sellix-shepherd .shepherd-button:hover {
    background: #4338ca;
}
.shepherd-element.sellix-shepherd .shepherd-button.shepherd-button-secondary {
    background: white;
    color: #475569;
    border: 1px solid #e2e8f0;
}
.shepherd-element.sellix-shepherd .shepherd-button.shepherd-button-secondary:hover {
    background: #f8fafc;
    color: #0f172a;
}
.shepherd-element.sellix-shepherd .shepherd-arrow:before {
    background: white;
    border: 1px solid #e2e8f0;
}
.shepherd-modal-overlay-container.shepherd-modal-is-visible {
    opacity: 0.45;
}
`, "",{"version":3,"sources":["webpack://./src/components/tour/tour.css"],"names":[],"mappings":"AAAA,2DAA2D;AAC3D;IACI,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB;;0CAEsC;IACtC,yCAAyC;IACzC,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,6DAA6D;IAC7D,uBAAuB;AAC3B;AACA;IACI,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IACI,0CAA0C;IAC1C,eAAe;AACnB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,uBAAuB;AAC3B;AACA;IACI,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,QAAQ;AACZ;AACA;IACI,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,iCAAiC;AACrC;AACA;IACI,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,cAAc;IACd,yBAAyB;AAC7B;AACA;IACI,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;AACA;IACI,aAAa;AACjB","sourcesContent":["/* Sellix Shepherd theme — overrides default Shepherd CSS */\n.shepherd-element.sellix-shepherd {\n    background: white;\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    box-shadow:\n        0 20px 25px -5px rgba(0, 0, 0, 0.1),\n        0 8px 10px -6px rgba(0, 0, 0, 0.1);\n    font-family: \"Geist\", \"Inter\", sans-serif;\n    max-width: 360px;\n}\n.shepherd-element.sellix-shepherd .shepherd-content {\n    border-radius: 12px;\n    overflow: hidden;\n}\n.shepherd-element.sellix-shepherd .shepherd-header {\n    background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);\n    padding: 14px 16px 12px;\n}\n.shepherd-element.sellix-shepherd .shepherd-title {\n    color: white !important;\n    font-size: 14px;\n    font-weight: 600;\n    letter-spacing: -0.01em;\n}\n.shepherd-element.sellix-shepherd .shepherd-cancel-icon {\n    color: rgba(255, 255, 255, 0.7) !important;\n    font-size: 18px;\n}\n.shepherd-element.sellix-shepherd .shepherd-cancel-icon:hover {\n    color: white !important;\n}\n.shepherd-element.sellix-shepherd .shepherd-text {\n    color: #334155;\n    font-size: 13px;\n    line-height: 1.55;\n    padding: 14px 16px 10px;\n}\n.shepherd-element.sellix-shepherd .shepherd-footer {\n    padding: 8px 12px 12px;\n    border-top: 1px solid #f1f5f9;\n    background: #fafbfc;\n    display: flex;\n    justify-content: flex-end;\n    gap: 6px;\n}\n.shepherd-element.sellix-shepherd .shepherd-button {\n    background: #4f46e5;\n    color: white;\n    font-size: 12px;\n    font-weight: 500;\n    padding: 6px 14px;\n    border-radius: 6px;\n    border: none;\n    cursor: pointer;\n    transition: background 120ms ease;\n}\n.shepherd-element.sellix-shepherd .shepherd-button:hover {\n    background: #4338ca;\n}\n.shepherd-element.sellix-shepherd .shepherd-button.shepherd-button-secondary {\n    background: white;\n    color: #475569;\n    border: 1px solid #e2e8f0;\n}\n.shepherd-element.sellix-shepherd .shepherd-button.shepherd-button-secondary:hover {\n    background: #f8fafc;\n    color: #0f172a;\n}\n.shepherd-element.sellix-shepherd .shepherd-arrow:before {\n    background: white;\n    border: 1px solid #e2e8f0;\n}\n.shepherd-modal-overlay-container.shepherd-modal-is-visible {\n    opacity: 0.45;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
